import { render } from "./Servers.vue?vue&type=template&id=51410652"
import script from "./Servers.vue?vue&type=script&lang=js"
export * from "./Servers.vue?vue&type=script&lang=js"

import "./Servers.vue?vue&type=style&index=0&id=51410652&lang=scss"

import exportComponent from "/var/www/swm.yozorawolf.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__